import angular from 'angular';

import ApplicationWalkthrough from './application';
import ClosedWalkthrough from './closed';
import GetPaidWalkthrough from './getPaid';
import StartWorkWalkthrough from './startWork';

import WalkthroughController from './walkthroughController';
import WalkthroughFactory from './walkthroughFactory';


export default angular.module('app.appDetail.walkthrough', [
    ApplicationWalkthrough,
    ClosedWalkthrough,
    GetPaidWalkthrough,
    StartWorkWalkthrough
])
    .controller('WalkthroughController', WalkthroughController)
    .factory('WalkthroughFactory', WalkthroughFactory)
    .run(($templateCache) => {
        $templateCache.put('app/appDetail/walkthrough/walkthrough.html', require('./walkthrough.html')); // eslint-disable-line global-require
        $templateCache.put('app/appDetail/walkthrough/walkthroughNotFound.html', require('./walkthroughNotFound.html')); // eslint-disable-line global-require
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/appDetail/walkthrough/index.js